import React from 'react';
import { Button, ButtonProps } from '@material-ui/core';
import { ReactComponent as Vector } from '../../assets/icons/vector.svg';

export const ButtonOne: React.FC<ButtonProps> = (props) => {
  const disabledStyle = props.disabled
    ? {
        ...props.style,
        backgroundColor: '#6F707B',
        color: 'white',
        fontWeight: 500,
      }
    : { ...props.style };
  return (
    <Button
      {...props}
      disableRipple
      style={disabledStyle}
      startIcon={props.disabled ? <Vector style={{ margin: '1px' }} /> : props.startIcon}
    />
  );
};
